
import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import Layout from '@/components/layout/Layout';
import ChildrenHero from '@/components/children/ChildrenHero';
import ChildrenBenefits from '@/components/children/ChildrenBenefits';
import ChildrenJourney from '@/components/children/ChildrenJourney';
import ChildrenTestimonials from '@/components/children/ChildrenTestimonials';
import ChildrenFAQ from '@/components/children/ChildrenFAQ';
import { preloadCriticalImages } from '@/utils/optimizeImages';
import AboutCTA from '@/components/about/AboutCTA';

const ChildrenPianoLessons = () => {
  // Preload critical images for performance
  useEffect(() => {
    preloadCriticalImages([
      '/lovable-uploads/c3099eea-1cdc-462a-9e3c-85f757436352.png'
    ]);
  }, []);

  return (
    <Layout>
      <div id="top"></div>
      <Helmet>
        <title>Klaverundervisning for børn | Sjov og lærerig musikundervisning</title>
        <meta name="description" content="Engagerende og legende klaverundervisning for børn (6+ år). Udvikl dit barns musikalske evner i et trygt og inspirerende miljø. Book en gratis prøvetime!" />
        <link rel="canonical" href="https://pianoundervisning.dk/klaverundervisning-born" />
        <meta property="og:title" content="Klaverundervisning for børn | Sjov og lærerig musikundervisning" />
        <meta property="og:description" content="Engagerende og legende klaverundervisning for børn (6+ år). Udvikl dit barns musikalske evner i et trygt og inspirerende miljø." />
        <meta property="og:url" content="https://pianoundervisning.dk/klaverundervisning-born" />
        <meta property="og:type" content="website" />
        <meta name="keywords" content="klaverundervisning børn, musikundervisning for børn, klaver for børn, piano for børn, børnevenlig klaverundervisning" />
      </Helmet>

      <ChildrenHero />
      <ChildrenBenefits />
      <ChildrenJourney />
      <ChildrenTestimonials />
      <ChildrenFAQ />
      <AboutCTA 
        title="Start dit barns musikalske rejse"
        description="Giv dit barn glæden ved musik gennem sjov og engagerende klaverundervisning, der skaber et solidt musikalsk fundament."
        primaryButtonText="Book gratis prøvetime"
        secondaryButtonText="Se alle undervisningstilbud"
      />
    </Layout>
  );
};

export default ChildrenPianoLessons;
